import React from "react";
import PageHero from "../components/PageHero";
import ContactPanel from "../components/ContactPanel";
import SEO from "../components/SEO";
import { assets } from "../data/siteData";

export default function ContactPage() {
  return (
    <div className="pt-[104px]">
      <SEO
        title="Contact Us | Water Treatment & Pump Solutions in Kolkata, Newtown, Rajarhat, West Bengal"
        description="Contact Hydrotec Solutions for water treatment plants, RO systems, bacteria removal, pump systems, and chlorination in Kolkata, Newtown, Rajarhat, and West Bengal. Call +91 8697702088 or email info@hydroteclimited.com."
        keywords="contact water treatment Kolkata, water purification company Kolkata contact, Hydrotec Solutions Kolkata, water solutions Newtown contact"
        canonical="https://hydroteclimited.com/contact"
      />
      
      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
        <ContactPanel />
      </section>
    </div>
  );
}